/**
 * AppSync conflict detection soft-deletes records by setting `_deleted`. The field is in
 * the GraphQL responses but not on the generated model types, so read it through this
 * helper rather than an untyped index (`item['_deleted']`).
 */
export function isNotDeleted(item: object): boolean {
    return !(item as { _deleted?: boolean | null })._deleted
}
